export default {
	data() {
		return {
			defaultBgImg: require('@/assets/Home/logo.png')
		}
	},
	
	// 计算属性
	computed: {
		
		// 截取字符串长度并添加省略号
		replaceText: function() {
			return function(text, numSub) {
				if(text == null){
					return "";
				}
				if(text.length > numSub){
					return text.substring(0, numSub - 1) + "...";
				}
				return text;
			}
		},
		
		// 清除日期具体时间 00:00:00
		clearDateHour: function() {
			let newTime = [];
			return function(val) {
				if(!val) return '';
				newTime = val.split(' ');
				return newTime[0];
			}
		},
		
		// 根据月份显示英文单词
		replaceMonthEn: function() {
			return function(val) {
				if(!val) return '';
				switch(val) {
					case '01':
						return 'Jan';
						break;
					case '02':
						return 'Feb';
						break;
					case '03':
						return 'Mar';
						break;
					case '04':
						return 'Apr';
						break;
					case '05':
						return 'May';
						break;
					case '06':
						return 'Jun';
						break;
					case '07':
						return 'Jul';
						break;
					case '08':
						return 'Aug';
						break;
					case '09':
						return 'Sept';
						break;
					case '10':
						return 'Oct';
						break;
					case '11':
						return 'Nov';
						break;
					case '12':
						return 'Dec'
				}
			}
		},
		
		// 当语言处于英语的状态下日期需要转换为日-月-年
		nowEnglishStatus: function() {
			return function(val) {
				if(!val) return '';
				let date = this.clearDateHour(val).split('-');
				return date[2] + '-' + this.replaceMonthEn(date[1]) + '-' + date[0];
			}
		},
		
		// 背景图无图处理
		bgImgNotCover: function() {
			return function(val) {
				if(!val) return this.defaultBgImg;
				if(val.indexOf('jpg') >= 0 || val.indexOf('png') >= 0 || val.indexOf('gif') >= 0) {
					return val;
				}else{
					return this.defaultBgImg;
				}
			}
		},
		
		// 背景图无图处理
		timestampConvertDate: function() {
			return function(val, state=false) {
				// 创建一个新的 Date() 对象并传入时间戳作为参数
				var dateObj = new Date(val);
				// 获取年、月、日等信息
				var year = dateObj.getFullYear(); // 年份
				var month = dateObj.getMonth() + 1; // 月份（注意要加上1）
				var day = dateObj.getDate(); // 日期
				var hours = dateObj.getHours(); // 小时
				var minutes = dateObj.getMinutes(); // 分钟
				var seconds = dateObj.getSeconds(); // 秒钟
				return status ? year + "-" + month + "-" + day +' '+hours + ":" + minutes + ":" + seconds : year + "-" + month + "-" + day;
			}
		},
		
	},
	methods:{
		
	}
}